import { z } from "zod";

export const createGatheringSchema = z.object({
  title: z
    .string()
    .min(1, "Title is required")
    .max(150, "Title must be 150 characters or less"),
  description: z
    .string()
    .max(1000, "Description must be 1000 characters or less")
    .optional(),
  date: z.string().datetime("Invalid date format"),
  endDate: z.string().datetime("Invalid date format").optional(),
  venueType: z
    .enum(["BOOKSTORE", "CAFE", "LIBRARY", "PARK", "HOME", "OTHER"])
    .optional(),
  venueName: z.string().max(200).optional(),
  neighborhood: z.string().max(100).optional(),
  address: z.string().max(500).optional(),
  capacity: z
    .number()
    .min(2, "Capacity must be at least 2")
    .max(500, "Capacity must be 500 or less")
    .optional(),
  discussionFocus: z.string().max(500).optional(),
  readingRoomId: z.string().optional(),
  // Phase 4 PR7 (#296): organizer-set per-gathering public-discovery flag.
  // Service forces this to false when the parent club is not discoverable.
  publiclyVisible: z.boolean().optional(),
});

export const updateGatheringSchema = createGatheringSchema.partial();

export const rsvpSchema = z.object({
  status: z.enum(["GOING", "MAYBE", "CANT"]),
});

export const gatheringQuerySchema = z.object({
  upcoming: z.coerce.boolean().default(true),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
});

export type CreateGatheringInput = z.infer<typeof createGatheringSchema>;
export type UpdateGatheringInput = z.infer<typeof updateGatheringSchema>;
export type RSVPInput = z.infer<typeof rsvpSchema>;
export type GatheringQueryInput = z.infer<typeof gatheringQuerySchema>;
